import {
  FormControl,
  FormHelperText,
  FormLabel,
  ToggleButtonGroup,
} from '@mui/material';
import { Controller } from 'react-hook-form';

export default function UseFormToggle({
  children,
  control,
  name,
  label,
  error,
  helperText,
  fullWidth = false,
  exclusive = false,
  required = false,
  asNumber = false,
  asBoolean = false,
  ...props
}: any) {
  const getValue = (value: string) => {
    if (asNumber) {
      return +value;
    }
    if (asBoolean) {
      return value === 'true';
    }

    return value;
  };

  return (
    <FormControl error={error} {...props}>
      <FormLabel>
        {label} {required && '*'}
      </FormLabel>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <ToggleButtonGroup
            exclusive={exclusive}
            fullWidth={fullWidth}
            value={value}
            onChange={(event: any) => {
              onChange(getValue(event.target.value));
            }}
          >
            {children}
          </ToggleButtonGroup>
        )}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
